import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { LaborTableDataTable } from "./LaborTableDataTable";
import { isMobile, currencyValue } from "utils/common";
import {
  searchContainerColumns,
  expandedItemsSearch,
  xlsxSettings,
  xlsxcolumns,
  pendingXlsxcolumns,
  fcNaXLSXcolumns,
  filterColumns,
  pendingPricesTabColumns,
  pendingItemsSearch,
  fcNaColumns,
  verifyDataColumns,
} from "./utils";
import {
  updateSearchFilterValue,
  CustomerRowSelection,
  resetSelectedRows,
  editPricingRates,
  approveRejectPricing,
  verifyCurrentRates,
  editExpPrice,
} from "store/laborTable/actionCreator";
import InputField from "common/customInputField";
import Modal from "common/modal";
import EditExceptionPriceModal from "common/editExceptionPriceModal";
import { toast } from "react-toastify";
import "./style.scss";

const SearchTable = () => {
  const dispatch = useDispatch();
  const [mobileView, setMobileView] = useState(false);
  const [showVerifyPricingModal, setShowVerifyPricingModal] = useState(false);
  const [editLaborCodeModalData, setEditLaborCodeModalData] = useState({});
  const [editExpPricingData, setEditExpPricingData] = useState({});
  const [isNPchecked, setIsNPchecked] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState({});
  const [showEditLaborCodeModal, setShowEditLaborCodeModal] = useState(false);
  const [showEditExpPricingModal, setShowEditExpPricingModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [disablePricingFields, setDisablePricingFields] = useState(false);
  const [billRateError, setBillRateError] = useState("");
  const [expPriceValid, setExpPriceValid] = useState("");
  const [installerPayRateError, setInstallerPayRateError] = useState("");
  const [isActionMobile, setIsActionMobile] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [showExpWarningModal, setShowExpWarningModal] = useState(false);
  const [showApprovalButtons, setShowApprovalButtons] = useState(false);
  const { searchFilterValue, tableList, isSelectAllChecked, tableSearchFields } = useSelector(
    (state) => state.laborTable,
  );

  const { fcRole, sub, storeCcn } = useSelector((state) => state.loggedInUser);

  const tempFilterList = tableList.filter((row) => {
    const columnsTemp = filterColumns;
    return columnsTemp.some((column) => {
      const variable = row[column] == null ? "" : row[column].toString();
      return (
        variable
          .replace(/[^a-zA-Z0-9]/g, "")
          .toLowerCase()
          .indexOf(searchFilterValue.replace(/[^a-zA-Z0-9]/g, "").toLowerCase()) > -1
      );
    });
  });
  const filteredTableList = tempFilterList;

  useEffect(() => {
    const handleResize = () => {
      if (!isMobile()) {
        setMobileView(false);
      } else {
        setMobileView(true);
      }
    };
    window.addEventListener("resize", handleResize);
    if (isMobile()) {
      handleResize();
    }
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [mobileView]);

  const getPercentReturn = (totalProfit, loss) => {
    return (((totalProfit - loss) / totalProfit) * 100).toFixed(1);
  };

  const formatPercentReturn = (laborBillRate, installerPayRate) => {
    return isNaN(getPercentReturn(laborBillRate, installerPayRate))
      ? "N/A"
      : getPercentReturn(laborBillRate, installerPayRate) + "%";
  };

  let searchTableHeader = searchContainerColumns;
  let pendingTabColumns = pendingPricesTabColumns;
  let pendingItemsSearchCols = pendingItemsSearch;
  let expandedItems = expandedItemsSearch;

  if (fcRole === "FcNA") {
    searchTableHeader = fcNaColumns;
    expandedItems = fcNaColumns;
  } else if (fcRole === "FcOpsMgr" || fcRole === "FcStoreManager") {
    searchTableHeader = searchContainerColumns;
    pendingTabColumns = pendingPricesTabColumns;
    pendingItemsSearchCols = pendingItemsSearch;
    expandedItems = expandedItemsSearch;
  } else if (fcRole === "FcAdmin" || fcRole === "FcOtherEE" || fcRole === "FcEstimator" || fcRole === "FcSalesRep") {
    searchTableHeader = searchContainerColumns.filter((col) => col.name !== "Checkbox" && col.name !== "Actions");
  } else {
    searchTableHeader = searchContainerColumns.filter((col) => col.name !== "Actions");
    pendingTabColumns = pendingPricesTabColumns.filter((col) => col.name !== "Actions");
  }

  const selectedRecords = tableList && tableList.filter((row) => row.isSelected === true);

  let modelMessage = "";
  let saveButtonText = "";
  let title = "";
  let singleApprove = false;
  let singleReject = false;
  if (showEditLaborCodeModal) {
    title = "Edit Labor Code Rates for Store";
    saveButtonText = "Save";
  } else if (showEditExpPricingModal) {
    title = "Edit Exception Price";
    saveButtonText = "Save";
  } else if (showApproveModal) {
    title = "Confirm Approve";
    saveButtonText = "Approve";
    if (selectedRecords.length == 1 || isActionMobile) {
      singleApprove = true;
    } else {
      modelMessage = `Are you sure you want to approve the new prices for the selected ${selectedRecords.length} store records? `;
    }
  } else if (showRejectModal) {
    title = "Confirm Reject";
    saveButtonText = "Reject";
    if (selectedRecords.length == 1 || isActionMobile) {
      singleReject = true;
    } else {
      modelMessage = `Are you sure you want to reject  the new prices for the selected ${selectedRecords.length} store records?`;
    }
  } else if (showVerifyPricingModal) {
    title = "Confirm Verify";
    saveButtonText = "Confirm";
    modelMessage = `Are you sure you want to update the Verification time for all prices under store ${storeCcn}?`;
  }

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    dispatch(updateSearchFilterValue(value));
  };

  const checkPricingValidation = (billRate, installerPayRate) => {
    let valid = true;
    setBillRateError("");
    setInstallerPayRateError("");
    if (billRate && billRate.length > 0 && installerPayRate && installerPayRate.length > 0) {
      if (parseFloat(billRate) === parseFloat(0)) {
        valid = false;
        setBillRateError("Labor Bill Rate cannot be 0");
      }
      if (billRate && installerPayRate && parseFloat(billRate) < parseFloat(installerPayRate)) {
        valid = false;
        setInstallerPayRateError("Installer Pay Rate cannot be more than Bill Rate");
      }
      if (
        parseFloat(billRate) === parseFloat(editLaborCodeModalData.laborBillRateNew) &&
        parseFloat(installerPayRate) === parseFloat(editLaborCodeModalData.installerPayRateNew)
      ) {
        valid = false;
        setBillRateError("New Price cannot be the same as Pending Price");
        setInstallerPayRateError("New Price cannot be the same as Pending Price");
      }
    } else if ((!billRate && billRate.length == 0) || (!installerPayRate && installerPayRate.length == 0)) {
      valid = false;
      billRate.length == 0 ? setBillRateError("Please enter a value") : setBillRateError("");
      installerPayRate.length == 0 ? setInstallerPayRateError("Please enter a value") : setInstallerPayRateError("");
    }

    if (billRate === "NP" && installerPayRate === "NP") {
      if (
        billRate === "NP" &&
        !tableList[editLaborCodeModalData.elementIndex].laborBillRate &&
        installerPayRate === "NP" &&
        !tableList[editLaborCodeModalData.elementIndex].installerPayRate &&
        editLaborCodeModalData.approvalStatus !== "INITIALIZE"
      ) {
        valid = false;
        setBillRateError("New Price cannot be the same as Current Price");
        setInstallerPayRateError("New Price cannot be the same as Current Price");
      }
      if (
        billRate === editLaborCodeModalData.laborBillRateNew &&
        installerPayRate === editLaborCodeModalData.installerPayRateNew &&
        editLaborCodeModalData.approvalStatus === "PENDING"
      ) {
        valid = false;
        setBillRateError("New Price cannot be the same as Pending Price");
        setInstallerPayRateError("New Price cannot be the same as Pending Price");
      }
    }
    return valid;
  };

  const checkExpPricingValidation = () => {
    let valid = true;
    if (parseFloat(editExpPricingData.exceptionBillRate) < parseFloat(editExpPricingData.expInstallerPayRate)) {
      setExpPriceValid("");
      valid = false;
      setExpPriceValid("Exception Price cannot be less than Exception Installer Pay Rate");
    }
    return valid;
  };

  const handleChange = (e, isExpEdit) => {
    const key = e.target.id;
    const value = e.target.value;
    if (isExpEdit) {
      if (key === "exceptionBillRate") {
        editExpPricingData.exceptionBillRate = value;
      }
      if (key === "expInstallerPayRate") {
        editExpPricingData.expInstallerPayRate = value;
      }
      setEditExpPricingData({ ...editExpPricingData });
    } else {
      if (key === "billRate") {
        editLaborCodeModalData.laborBillRate = value;
      } else if (key === "installerPayRate") {
        editLaborCodeModalData.installerPayRate = value;
      }
      checkPricingValidation(editLaborCodeModalData.laborBillRate, editLaborCodeModalData.installerPayRate);
      setEditLaborCodeModalData({ ...editLaborCodeModalData });
    }
  };

  const editLaborCodeModal = () => {
    return (
      <div className="container-fluid laborCode-Modal">
        <div className="laborCode-Modal__fields">
          <form className="laborCode-Modal__fields__form">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                <div className="form-group">
                  <label htmlFor="laborCode" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">Labor Code</span>
                  </label>
                  <input
                    type="text"
                    className="form-control laborCode-Modal__fields__form-group__item--input-box"
                    id="laborCode"
                    disabled={true}
                    value={`${editLaborCodeModalData.laborCode}- ${editLaborCodeModalData.laborCodeDesc} `}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                {" "}
                <div className="form-group">
                  <label htmlFor="storeNumber" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">Store Number</span>
                  </label>
                  <input
                    type="text"
                    className="form-control laborCode-Modal__fields__form-group__item--input-box"
                    id="storeNumber"
                    disabled={true}
                    value={editLaborCodeModalData.storeNbr}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                {" "}
                <InputField
                  type="text"
                  label="Bill Rate ($)"
                  id="billRate"
                  fieldClasses="form-control laborCode-Modal__fields__form-group__item--input-box"
                  value={!editLaborCodeModalData.laborBillRate ? "" : editLaborCodeModalData.laborBillRate}
                  onChange={handleChange}
                  disabled={disablePricingFields}
                  isRequired={false}
                  errorMsg={billRateError}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                {" "}
                <InputField
                  type="text"
                  label="Installer Pay Rate ($)"
                  id="installerPayRate"
                  fieldClasses="form-control laborCode-Modal__fields__form-group__item--input-box"
                  value={!editLaborCodeModalData.installerPayRate ? "" : editLaborCodeModalData.installerPayRate}
                  onChange={handleChange}
                  disabled={disablePricingFields}
                  isRequired={false}
                  errorMsg={installerPayRateError}
                />
              </div>

              <div className="d-flex col-12 col-sm-12 col-md-12 col-lg-12 laborCode-Modal__fields__form-group">
                <div className="d-flex laborCode-Modal__fields__form-group__space">
                  <input
                    type="checkbox"
                    aria-label="Checkbox select all of rows"
                    className="laborCode-Modal__fields__form-group__checkbox--input"
                    onChange={handleNPchecked}
                    checked={isNPchecked}
                  />
                </div>
                <div className="d-flex laborCode-Modal__fields__form-group__space">
                  <label htmlFor="installerPayRate" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">
                      Mark Price as NP (No Price)
                    </span>
                  </label>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                {" "}
                <div className="form-group">
                  <label htmlFor="createdBy" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">Created by</span>
                  </label>
                  <input
                    type="text"
                    className="form-control laborCode-Modal__fields__form-group__item--input-box"
                    id="createdBy"
                    disabled={true}
                    value={editLaborCodeModalData.createdBy}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                {" "}
                <div className="form-group">
                  <label htmlFor="LastApprovedby" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">Last Approved by</span>
                  </label>
                  <input
                    type="text"
                    className="form-control laborCode-Modal__fields__form-group__item--input-box"
                    id="LastApprovedby"
                    disabled={true}
                    value={editLaborCodeModalData.approvedBy}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                {" "}
                <div className="form-group">
                  <label htmlFor="CreatedDate" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">Created Date</span>
                  </label>
                  <input
                    type="text"
                    className="form-control laborCode-Modal__fields__form-group__item--input-box"
                    id="CreatedDate"
                    disabled={true}
                    value={editLaborCodeModalData.createdTimestamp}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                {" "}
                <div className="form-group">
                  <label htmlFor="UpdatedDate" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">Updated Date</span>
                  </label>
                  <input
                    type="text"
                    className="form-control laborCode-Modal__fields__form-group__item--input-box"
                    id="UpdatedDate"
                    disabled={true}
                    value={editLaborCodeModalData.updatedTimeStamp}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                {" "}
                <div className="form-group">
                  <label htmlFor="CurrentPercentReturn" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">Current Percent Return</span>
                  </label>
                  <input
                    type="text"
                    className="form-control laborCode-Modal__fields__form-group__item--input-box"
                    id="CurrentPercentReturn"
                    disabled={true}
                    value={editLaborCodeModalData.percentReturn}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 laborCode-Modal__fields__form-group">
                {" "}
                <div className="form-group">
                  <label htmlFor="LaborCodeDescription" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">Labor Code Description</span>
                  </label>
                  <textarea
                    className="form-control laborCode-Modal__fields__form-group__item--text-area"
                    id="LaborCodeDescription"
                    disabled={true}
                    value={`${editLaborCodeModalData.laborCode}- ${editLaborCodeModalData.laborCodeDesc} : ${editLaborCodeModalData.laborCodeDescExt}`}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  };

  const handleNPchecked = (e) => {
    setIsNPchecked(!isNPchecked);
    const tempLaborCodeModalData = { ...editLaborCodeModalData };
    if (e.target.checked) {
      tempLaborCodeModalData.laborBillRate = "NP";
      tempLaborCodeModalData.installerPayRate = "NP";
      setDisablePricingFields(true);
      checkPricingValidation(tempLaborCodeModalData.laborBillRate, tempLaborCodeModalData.installerPayRate);
    } else {
      tempLaborCodeModalData.laborBillRate = tableList[tempLaborCodeModalData.elementIndex].laborBillRate;
      tempLaborCodeModalData.installerPayRate = tableList[tempLaborCodeModalData.elementIndex].installerPayRate;
      setDisablePricingFields(false);
    }
    setEditLaborCodeModalData({ ...tempLaborCodeModalData });
  };

  const singleApproveRejectModal = () => {
    return (
      <div className="container-fluid laborCode-Modal">
        <div className="laborCode-Modal__fields">
          <form className="laborCode-Modal__fields__form">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                <div className="form-group">
                  <label htmlFor="laborCode" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">Labor Code</span>
                  </label>
                  <input
                    readOnly
                    type="text"
                    className="form-control laborCode-Modal__fields__form-group__item--input-box"
                    value={`${selectedRowData.laborCode}- ${selectedRowData.laborCodeDesc} `}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                {" "}
                <div className="form-group">
                  <label htmlFor="storeNumber" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">Store Number</span>
                  </label>
                  <input
                    readOnly
                    type="text"
                    className="form-control laborCode-Modal__fields__form-group__item--input-box"
                    value={selectedRowData.storeNbr}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                {" "}
                <div className="form-group">
                  <label htmlFor="billRate" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">Current Bill Rate</span>
                  </label>
                  <input type="text" readOnly value={currencyValue(selectedRowData.laborBillRate)} />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                {" "}
                <div className="form-group">
                  <label htmlFor="installerPayRate" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">Current Installer Pay Rate</span>
                  </label>
                  <input type="text" readOnly value={currencyValue(selectedRowData.installerPayRate)} />
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                {" "}
                <div className="form-group">
                  <label htmlFor="createdBy" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">New Bill Rate</span>
                  </label>
                  <input type="text" readOnly value={currencyValue(selectedRowData.laborBillRateNew)} />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 laborCode-Modal__fields__form-group">
                {" "}
                <div className="form-group">
                  <label htmlFor="LastApprovedby" className="laborCode-Modal__fields__form-group__label">
                    <span className="laborCode-Modal__fields__form-group__label--text">New Installer Pay Rate</span>
                  </label>
                  <input type="text" readOnly value={currencyValue(selectedRowData.installerPayRateNew)} />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  };

  const handleActions = async (data) => {
    if (data.exceptionPrice === "1") {
      setShowEditExpPricingModal(true);
      setEditExpPricingData({
        ...data,
        exceptionBillRate: data.laborBillRate,
        expInstallerPayRate: data.installerPayRate,
      });
    } else {
      setEditLaborCodeModalData(JSON.parse(JSON.stringify(data)));
      setIsNPchecked(false);
      setBillRateError("");
      setInstallerPayRateError("");
      setDisablePricingFields(false);
      setShowEditLaborCodeModal(true);
    }
  };

  const handleSave = () => {
    if (showEditLaborCodeModal) {
      let tempObj = {
        id: "",
        laborBillRate: "",
        installerPayRate: "",
        isNPchecked: "",
      };
      tempObj.id = editLaborCodeModalData.laborCodeStoreId;
      tempObj.laborBillRate = isNPchecked ? "null" : editLaborCodeModalData.laborBillRate;
      tempObj.installerPayRate = isNPchecked ? "null" : editLaborCodeModalData.installerPayRate;
      tempObj.isNPchecked = isNPchecked ? "TRUE" : "FALSE";
      let pricingValid = false;

      pricingValid = checkPricingValidation(
        isNPchecked ? "NP" : editLaborCodeModalData.laborBillRate,
        isNPchecked ? "NP" : editLaborCodeModalData.installerPayRate,
      );

      if (pricingValid) {
        if (parseFloat(editLaborCodeModalData.laborBillRate) === parseFloat(editLaborCodeModalData.installerPayRate)) {
          setShowWarningModal(true);
        } else {
          toast.promise(dispatch(editPricingRates(tempObj, editLaborCodeModalData.elementIndex)), {
            pending: "Saving",
            success: "Edited successfully.",
            error: "Failed to update, please try again.",
          });
          setShowEditLaborCodeModal(false);
          setShowWarningModal(false);
        }
      } else {
        setShowEditLaborCodeModal(true);
      }

      if (showWarningModal && pricingValid) {
        toast.promise(dispatch(editPricingRates(tempObj, editLaborCodeModalData.elementIndex)), {
          pending: "Saving",
          success: "Edited successfully.",
          error: "Failed to update, please try again.",
        });
        setShowEditLaborCodeModal(false);
        setShowWarningModal(false);
      }
    }

    if (showEditExpPricingModal) {
      const editPayload = {
        accountNumber: editExpPricingData.accountNumber,
        storeNumber: storeCcn,
        laborCodeId: editExpPricingData.laborCodeId,
        laborBillRate: editExpPricingData.exceptionBillRate,
        installerPayRate: editExpPricingData.expInstallerPayRate,
        updatedBy: sub,
      };
      const payload = {
        district: tableSearchFields.district,
        storeNumber: tableSearchFields.storeNumber,
        laborCode: tableSearchFields.laborCode,
        status: tableSearchFields.status,
        accountNumber: tableSearchFields.accountNumber ? [tableSearchFields.accountNumber] : [],
        parentNumber: tableSearchFields.parentNumber,
        priceType: tableSearchFields.priceType.label ? [tableSearchFields.priceType.label] : [], //['0','1']
      };
      let isValid = false;
      isValid = checkExpPricingValidation();
      if (isValid) {
        if (parseFloat(editExpPricingData.exceptionBillRate) === parseFloat(editExpPricingData.expInstallerPayRate)) {
          setShowExpWarningModal(true);
        } else {
          setShowEditExpPricingModal(false);
          dispatch(editExpPrice(editPayload, payload));
        }
      } else {
        setShowEditExpPricingModal(true);
      }

      if (isValid && showExpWarningModal) {
        setShowExpWarningModal(false);
        setShowEditExpPricingModal(false);
        dispatch(editExpPrice(editPayload, payload));
      }
    } else if (title === "Confirm Approve" || showApproveModal) {
      let approvePayload = [
        {
          id: "",
          approvedBy: "",
          type: "",
        },
      ];
      if (isActionMobile) {
        approvePayload = [
          {
            id: selectedRowData.laborCodeStoreId,
            approvedBy: sub, //TODO: CHANGE THE APPROVED BY TO loginId
            type: "Approve",
          },
        ];
      } else {
        approvePayload = selectedRecords.map((ele) => {
          return {
            id: ele.laborCodeStoreId,
            approvedBy: sub, //TODO: CHANGE THE APPROVED BY TO loginId
            type: "Approve",
          };
        });
      }
      toast.promise(
        dispatch(approveRejectPricing(approvePayload, isActionMobile ? [selectedRowData] : selectedRecords)),
        {
          pending: "Approving",
          success: "Items are Approved.",
          error: "Error while approving items, please try again.",
        },
      );
      setShowApproveModal(false);
      setShowApprovalButtons(false);
    } else if (title === "Confirm Reject" || showRejectModal) {
      let rejectPayload = [{ id: "", approvedBy: "", type: "" }];
      if (isActionMobile) {
        rejectPayload = [{ id: selectedRowData.laborCodeStoreId, approvedBy: sub, type: "Reject" }];
      } else {
        rejectPayload = selectedRecords.map((ele) => ({ id: ele.laborCodeStoreId, approvedBy: sub, type: "Reject" }));
      }
      toast.promise(
        dispatch(approveRejectPricing(rejectPayload, isActionMobile ? [selectedRowData] : selectedRecords)),
        {
          pending: "Rejecting items",
          success: "Items are rejected",
          error: "Error while rejecting items, please try again",
        },
      );
      setShowRejectModal(false);
      setShowApprovalButtons(false);
    } else if (showVerifyPricingModal) {
      let verifyPayload = { storeNumber: storeCcn };
      let searchPayload = {
        district: tableSearchFields.district,
        storeNumber: tableSearchFields.storeNumber,
        laborCode: tableSearchFields.laborCode,
        status: tableSearchFields.status,
        accountNumber: tableSearchFields.accountNumber ? [tableSearchFields.accountNumber] : [],
        parentNumber: tableSearchFields.parentNumber,
        priceType: tableSearchFields.priceType.label ? [tableSearchFields.priceType.label] : ["0", "1"],
      };

      toast.promise(dispatch(verifyCurrentRates(verifyPayload, searchPayload)), {
        pending: "Verifying current rates",
        success: "Items are verified",
        error: "Error while verifying items, please try again",
      });

      setShowVerifyPricingModal(false);
    }
  };

  const handleCancel = () => {
    if (showEditLaborCodeModal && !showWarningModal) {
      setShowEditLaborCodeModal(false);
    } else if (showVerifyPricingModal) {
      dispatch(resetSelectedRows());
      setShowVerifyPricingModal(false);
    } else if (showApproveModal) {
      dispatch(resetSelectedRows());
      setShowApproveModal(false);
      setShowApprovalButtons(false);
    } else if (showRejectModal) {
      dispatch(resetSelectedRows());
      setShowRejectModal(false);
      setShowApprovalButtons(false);
    } else if (showWarningModal) {
      setShowWarningModal(false);
    } else if (showEditExpPricingModal && !showExpWarningModal) {
      setShowEditExpPricingModal(false);
    } else if (showExpWarningModal) {
      setShowExpWarningModal(false);
    }
  };

  const handleVerifyBtn = (isMobile, data) => {
    setIsActionMobile(isMobile);
    setShowVerifyPricingModal(true);
  };

  const handleApproveBtn = (isMobile, data) => {
    setIsActionMobile(isMobile);
    if (data) {
      setSelectedRowData(data);
    }
    setShowApproveModal(true);
  };

  const handleRejectBtn = (isMobile, data) => {
    setIsActionMobile(isMobile);
    if (data) {
      setSelectedRowData(data);
    }
    setShowRejectModal(true);
  };

  const handleCustomerRowSelection = (id, selectedData) => {
    if (!showApprovalButtons) setShowApprovalButtons(true);
    setSelectedRowData(selectedData);
    dispatch(CustomerRowSelection(id));
  };

  return (
    <>
      <LaborTableDataTable
        tableHeader={fcRole === "FcStoreManager" ? verifyDataColumns : searchTableHeader}
        pendingPriceTabHeader={pendingTabColumns}
        tableBody={tableList}
        displaySearchFilter={true}
        isSelectAllChecked={isSelectAllChecked}
        filteredTableList={filteredTableList}
        searchFilterValue={searchFilterValue}
        handleSearchFilter={handleSearchFilter}
        handleCustomerRowSelection={handleCustomerRowSelection}
        expandedItems={expandedItems}
        pendingItemsSearch={pendingItemsSearchCols}
        handleActions={handleActions}
        handleVerifyBtn={handleVerifyBtn}
        handleApproveBtn={handleApproveBtn}
        handleRejectBtn={handleRejectBtn}
        xlsxSettings={xlsxSettings}
        xlsxcolumns={xlsxcolumns}
        pendingXlsxcolumns={pendingXlsxcolumns}
        fcNaXLSXcolumns={fcNaXLSXcolumns}
        showApprovalButtons={showApprovalButtons}
        setShowApprovalButtons={setShowApprovalButtons}
      />
      {(showEditLaborCodeModal || showVerifyPricingModal || showApproveModal || showRejectModal) && (
        <Modal
          title={title}
          saveButtonText={saveButtonText}
          closeButtonText={"Cancel"}
          handleSave={handleSave}
          handleCancel={handleCancel}
          saveButtonClass={title === "Confirm Reject" && "rejectBtn"}
          size={mobileView ? "sm" : "lg"}
        >
          {showEditLaborCodeModal ? (
            editLaborCodeModal()
          ) : singleApprove || singleReject ? (
            singleApproveRejectModal()
          ) : (
            <p className="confirmation-text">{modelMessage}</p>
          )}
        </Modal>
      )}
      {showEditExpPricingModal && (
        <EditExceptionPriceModal
          handleSave={handleSave}
          editData={editExpPricingData}
          handleCancel={handleCancel}
          size={mobileView ? "sm" : "lg"}
          handleChange={handleChange}
          expPriceValid={expPriceValid}
        />
      )}
      {showWarningModal ||
        (showExpWarningModal && (
          <Modal
            title={"Are you Sure"}
            saveButtonText={"Confirm"}
            closeButtonText={"Cancel"}
            handleSave={handleSave}
            handleCancel={handleCancel}
            size={mobileView ? "sm" : "lg"}
          >
            <p className="confirmation-text">
              Exception Bill Rate and Exception Installer Pay Rate are same. Are you sure you want to continue?
            </p>
          </Modal>
        ))}
    </>
  );
};

export default SearchTable;
